import { render, staticRenderFns } from "./AgingTable.vue?vue&type=template&id=87bfb3c2&"
import script from "./AgingTable.vue?vue&type=script&lang=js&"
export * from "./AgingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87bfb3c2')) {
      api.createRecord('87bfb3c2', component.options)
    } else {
      api.reload('87bfb3c2', component.options)
    }
    module.hot.accept("./AgingTable.vue?vue&type=template&id=87bfb3c2&", function () {
      api.rerender('87bfb3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/reports/AgingTable.vue"
export default component.exports